export default (selectedImages, opened, quantity, minimum, alreadySelected=[], mainEventId, withImages=[]) => ({
    opened,
    quantity,
    minimum,
    selectedImages,
    alreadySelected,

    tab: 'all',
    imagesCount: 0,
    favoritesCount: 0,

    init() {
        this.$watch('tab', () => this.showImages())
        this.$watch('opened', (open) => {
            if (!open) return
            this.showImages()
            this.$nextTick(() => this.dispatchCanSubmit())
        })
    },

    dispatchCanSubmit() {
        this.$dispatch('can-submit-select', this.selectedImages.length >= this.minimum && this.selectedImages.length <= this.quantity)
    },

    getLabel({event_name, event_date}) {
        return (`
            <div class='flex gap-2 divide-x items-center'>
                <span class='text-xs text-gray-700'>${event_date}</span>
                <span class='pl-2 text-gray-800'>${event_name}</span>
            </div>
        `).replace(/\r\n|\s+/g, ' ')
    },

    showImages() {
        if(!this.opened) {
            return;
        }

        this.$nextTick(() => {
            const selectedImagesIds = _.map(this.selectedImages, 'id');

            this.$dispatch('customer-images::restart', {
                params: {
                    favorite: this.tab === 'favorites' ? 1 : null
                },
                selected: selectedImagesIds
            })
        })
    },

    checkCanSelect() {
        return this.selectedImages.length < this.quantity
    },

    setSelectedImages({ detail: {selectedIds, selected, data} }) {
        if(this.alreadySelected.includes(data.id) && selected) {
            window.$wireui.dialog({
                title: 'DUPLICATE PHOTO WARNING',
                description: 'You\'re trying to add an image you\'ve already selected for other image slots.',
                icon: 'warning',
                close: 'OK, I understand',
            });
        }

        if(!_.has(this.selectedImages, {id: data.id}) && selected) {
            this.selectedImages.push({
                id: data.id,
                thumb: data.thumb,
                preview: data.preview,
                favorite: data.favorite,
            });
        }

        this.selectedImages = _.filter(
            this.selectedImages,
            ({id}) => selectedIds.includes(id)
        );

        this.dispatchCanSubmit();
    },

    nextLabel() {
        return `Select Photo (${this.selectedImages.length}/${this.quantity})`;
    },

    loadedImages($data) {
        this.imagesCount = $data.totalRowsCount;
        this.favoritesCount = $data.favoriteRows;
    }
})
